import React from "react"
import styled from "styled-components"
import PropTypes from "prop-types"
import { slideFromRight } from "./animations"

const Container = styled.div`
  flex: auto;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  color: white;
  padding: 1rem 1.414rem;
  > * {
    animation: 0.3s ${slideFromRight} ease-out;
    max-width: 1900px;
    margin-left: auto;
    margin-right: auto;
  }
`
// ScrollablePage defines a typical top-level page which scrolls
// vertically if necessary.
const ScrollablePage = ({ children }) => <Container>{children}</Container>

ScrollablePage.propTypes = {
  children: PropTypes.any,
}

export default ScrollablePage
